import { observer } from 'mobx-react';
import * as React from 'react';
import GroupsStore from '../../../../GroupsStore';
import { GroupResource } from '../../../../GroupsStore/Types';
import Body from './Body';
import Head from './Head';
import ModalStore from '../../../Modal/Store';
import GroupStore from '../../../../GroupStore';
import { MulticheckStore } from '../../../../Multicheck/Store';

interface Props {
  groupResources: GroupResource[];
  store: GroupsStore;
  modalStore: ModalStore;
  groupStore: GroupStore;
  multicheckStore: MulticheckStore<GroupResource>;
}

const Table: React.FC<Props> = ({
  groupResources,
  store,
  modalStore,
  groupStore,
  multicheckStore,
}) => (
  <table className="min-w-full divide-y divide-gray-300">
    <Head store={store} multicheckStore={multicheckStore} />
    <Body
      groups={groupResources}
      modalStore={modalStore}
      groupStore={groupStore}
      multicheckStore={multicheckStore}
    />
  </table>
);

export default observer(Table);
